export const IMPRESSIONS = 'Impressions';

export const UPDATE_EULA = 'UpdateEula';

export const CHECK_NEEDS_VERIFICATION = 'CheckNeedsVerification';

export const GANDALF_SESSION = 'GandalfSession';

export const UPDATE_USER_MERGE_CONSENTED = 'UpdateUserMergeConsented';

export const CHECK_USER_MERGE_CONSENT_REQUIRED =
  'CheckUserMergeConsentRequired';

export const UPDATE_CONSENT = 'UpdateConsent';

export const SET_TOKENS = 'SetTokens';

export const GLOBAL_SIGN_OUT = 'GlobalSignOut';

export const RUM_EVENTS = {
  EULA_IMPRESSION: 'EulaImpression',
  EULA_ACCEPT: 'EulaAccept',
  EULA_CANCEL: 'EulaCancel',
  EULA_ERROR: 'EulaError',
  EULA_AUTO_ACCEPT: 'EulaAutoAccept',
  EULA_AUTO_ACCEPT_ERROR: 'EulaAutoAcceptError',
};

export const RUM_EVENT_STATUS = {
  SUCCESS: 'Success',
  REQUEST_ERROR: 'RequestError',
  FINAL_ERROR: 'FinalError',
};

export enum SimplifiedLoginRumEvent {
  PAGE_IMPRESSION = 'SimplifiedSignInImpression',
  EMAIL_SUBMITTED = 'SimplifiedSignInEmailSubmitted',
  SOCIAL_SIGN_IN_CLICKED = 'SimplifiedSignInSocialClicked',
  LOGIN_CONVERSION_SUCCESS = 'SimplifiedLoginConversionSuccess',
  LOGIN_TIME_TO_COMPLETE = 'SimplifiedLoginTimeToComplete',
  LOGIN_TIME_TO_ACTION = 'SimplifiedLoginTimeToAction',
  LOGIN_ACTION_TO_COMPLETE = 'SimplifiedLoginActionToComplete',
  OTP_FILTERED = 'SimplifiedSignInOtpFiltered',
}

export const LOGIN_START_TIMESTAMP_KEY = 'simplified_login_start_ts';
export const LOGIN_ACTION_TIMESTAMP_KEY = 'simplified_login_action_ts';
export const LOGIN_ENTRY_METHOD_KEY = 'simplified_login_entry_method';
// SHA-256 of the normalized email entered on simplified login, persisted so
// pre-auth and post-auth RUM events can carry a per-email token. See utils/hashEmail.
export const LOGIN_EMAIL_HASH_KEY = 'simplified_login_email_hash';
// Persisted client_id for the current login session. Captured on the initial
// login page (where the URL carries ?client_id=...) so later contexts that
// lack the URL param (post-auth flows, Help page) can still attribute RUM
// events to the originating app client.
export const LOGIN_CLIENT_ID_KEY = 'simplified_login_client_id';

// Remember-me opt-in ('true'/'false'), carried across the IdP redirect to setTokens.
export const LOGIN_REMEMBER_ME_KEY = 'simplified_login_remember_me';
// IdP the user committed to for this login (e.g. 'AWSBuilderID').
export const LOGIN_LAST_SELECTED_IDP_KEY = 'simplified_login_last_selected_idp';
// JSON-encoded array of login methods (string[]) returned by /loginMethod for
// this user. Persisted pre-auth for the same reason as the IdP above.
export const LOGIN_METHOD_RESPONSE_KEY = 'simplified_login_method_response';
// Social provider (e.g. 'Google') when the user signed in through a social button.
export const LOGIN_SOCIAL_PROVIDER_KEY = 'simplified_login_social_provider';

export enum PostAuthRumEvent {
  // "Homecoming" related flows
  CONSENT_SHOWN = 'consent_shown',
  CONSENT_REJECTED = 'consent_rejected',
  CONSENT_ACCEPTED = 'consent_accepted',
  CONSENT_AUTO_ACCEPT = 'consent_auto_accept',
  REQUIRED_EMAIL_VERIFICATION_START = 'required_email_verification_start',
  REQUIRED_EMAIL_VERIFICATION_FAILED = 'required_email_verification_failed',
  USER_SUSPENDED = 'user_suspended',
  USER_DEACTIVATED = 'user_deactivated',
  SIGN_IN_SWITCH_NEEDED_B2I = 'sign_in_switch_needed_b2i',
  SIGN_IN_SWITCH_NEEDED_B2B = 'sign_in_switch_needed_b2b',
  PROFILE_COMPLETE = 'profile_complete',
  PROFILE_SHOWN = 'profile_shown',
  COMPLETE_PROFILE_RENDERED = 'complete_profile_rendered',
  SIMPLE_PROFILE_RENDERED = 'simple_profile_rendered',
  PROFILE_MERGE_NOTIFICATION = 'profile_merge_notification',

  // Other flows
  PAGE_TIME_OUT = 'page-time-out',
}
